import { authenticatedAxios } from './axios';
import getVehicleSummariesQuery, {
  type VehicleSummariesResponse
} from './GraphQL/queries/getVehicleSummaries';

const endpoint = `${process.env.CARVANA_APP_BFF_API}/graphql/`;

const AppraisalBffApi = {
  getSummaries: async () => {
    const response = await authenticatedAxios.post<VehicleSummariesResponse>(endpoint, {
      query: getVehicleSummariesQuery,
      variables: {}
    });
    response?.data?.errors?.forEach(error => {
      throw error;
    });
    return response.data.data;
  }
};

export default AppraisalBffApi;
